"use strict";
import t from "./index.es144.js";
function o(r) {
  return t.isObject(r) && r.isAxiosError === !0;
}
export {
  o as default
};
//# sourceMappingURL=index.es157.js.map
